// Keep PWA eligibility aligned with the backend catalog and checkout rules.
export const isPwaFinancial = (financial) => Boolean(financial) &&
  ['', 'ONLINE'].includes(String(financial.location ?? '').trim().toUpperCase());

export const pwaProduct = (product) => product && ({
  ...product,
  details: (product.details || []).map((detail) => ({
    ...detail,
    financials: (detail.financials || []).filter(isPwaFinancial),
  })).filter((detail) => detail.financials.length > 0),
});

export const pwaProductsResponse = (response) => {
  const filterProducts = (products) => products.map(pwaProduct)
    .filter((product) => product?.details.length > 0);
  if (Array.isArray(response)) return filterProducts(response);
  if (Array.isArray(response?.products)) {
    return { ...response, products: filterProducts(response.products) };
  }
  return response;
};
